<footer class="footer ">
    <div class="container-fluid">
        <div class="copyright pull-right">
            &copy;
            {{test | date: 'yyyy'}}, made with ASP.NET Core, Angular, Raspberry Pi, Let's Encrypt and etc.
        </div>
    </div>
</footer>
